import { render, staticRenderFns } from "./CrudStepperHeader.vue?vue&type=template&id=337ccc1e&"
import script from "./CrudStepperHeader.vue?vue&type=script&lang=ts&"
export * from "./CrudStepperHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('337ccc1e', component.options)
    } else {
      api.reload('337ccc1e', component.options)
    }
    module.hot.accept("./CrudStepperHeader.vue?vue&type=template&id=337ccc1e&", function () {
      api.rerender('337ccc1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Mantenedor/CrudStepperHeader.vue"
export default component.exports